// 약관·동의 문구의 **화면 표시용** 번역 (2026-09-22).
//
// 🔒 왜 별도 파일인가 — `legalDocuments.js` 의 `AGE_CONFIRM.label`·`hint` 는 `canonicalAgeConfirmText()` 를 통해
//    `user_policy_consent.document_hash` 의 원문이 된다. 그 문자열을 번역하면 이미 받은 동의의 해시와 어긋난다.
//    그래서 **해시 원문은 한국어 그대로 두고**, 화면에 보이는 글자만 여기서 옮긴다. 한국어 기본값은 그 상수를
//    그대로 쓰므로 원문이 바뀌면 한국어 화면도 같이 따라간다(사전에 없는 언어는 한국어로 폴백).
//
// 같은 이유로 `PRIVACY_SIGNUP_SUMMARY`(가입 화면 개인정보 요약)도 상수는 두고 표시만 옮긴다 — 이쪽은 해시에
// 들어가지 않지만, 원문을 한곳(법무 문서)에 두는 편이 관리하기 쉽다.
import { AGE_CONFIRM, PRIVACY_SIGNUP_SUMMARY } from "./legalDocuments";
import { tt } from "../i18n/tt";

/** 만 14세 확인 체크박스의 표시 문구. 해시 원문(AGE_CONFIRM)과 분리돼 있다. */
export function ageConfirmDisplay() {
  return {
    label: tt("a.pub.age14", AGE_CONFIRM.label),
    hint: tt("a.pub.age14hint", AGE_CONFIRM.hint),
  };
}

/** 가입 화면 「개인정보 수집·이용 동의」 요약 4줄(개인정보보호법 §22 고지 4요소). */
export function privacySignupSummaryRows() {
  const [collect, purpose, keep, refuse] = PRIVACY_SIGNUP_SUMMARY.rows;
  return [
    { k: tt("a.pub.psK1", collect.k), v: tt("a.pub.psV1", collect.v) },
    { k: tt("a.pub.psK2", purpose.k), v: tt("a.pub.psV2", purpose.v) },
    { k: tt("a.pub.psK3", keep.k), v: tt("a.pub.psV3", keep.v) },
    { k: tt("a.pub.psK4", refuse.k), v: tt("a.pub.psV4", refuse.v) },
  ];
}
